import { NewEmployeeForm } from "./_components/new-employee-form";

export default function NewEmployeePage() {
  return (
    <div className="md:h-[calc(100%-56px)] h-[calc(100vh-56px)]">
      <div className="h-full rounded-md">
        <NewEmployeeForm />
      </div>
    </div>
  );
}
